import dayjs from 'dayjs'
import { useRecoilState } from 'recoil'
import styled from 'styled-components'

import { useCookies, useGetHomeDatas } from '@/shared/hooks'
import useLockBodyScroll from '@/shared/hooks/useLockBodyScroll'
import { popupopen } from '@/shared/recoil/common/atom'
import { monitoredOpen } from '@/shared/utils/sentry/navigation'

const InProgressPopup = styled.div`
  z-index: 998;
  width: 100%;
  min-width: 360px;
  height: 100%;
  position: fixed;
  top: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
`

const InProgressPopupContent = styled.div<{ $scale: number }>`
  display: block;
  width: 420px;
  min-height: 170px;
  height: auto;
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.25);
  border-radius: 20px;
  overflow: hidden;
  transform: scale(${({ $scale }) => $scale});
  transform-origin: center center;

  @media all and (max-width: 540px) {
    width: 360px;
  }
  @media all and (max-width: 400px) {
    margin: 0 20px;
    width: 100%;
  }

  > img {
    width: 100%;
    cursor: pointer;
  }

  .bottom {
    display: flex;
    align-items: center;
    margin-top: -5px;
    padding: 12px 10px;
    width: 100%;
    gap: 10px;
    background-color: #f3f3f3;

    .left {
      color: #787878;
      text-decoration-line: underline;
    }

    .right {
      color: #454545;
      font-weight: 700;
    }

    .vertical_line {
      width: 1px;
      height: 16px;
      background-color: rgba(0, 0, 0, 0.3);
    }

    > button {
      cursor: pointer;
      border: none;
      background-color: transparent;
      flex: 1;
      padding: 10px 0;
      font-family: 'Noto Sans KR', sans-serif;
      font-size: 18px;
    }
  }
`

const Popup = () => {
  const datas = useGetHomeDatas()
  const [popopen, setPopOpen] = useRecoilState(popupopen)
  const cookie = useCookies()

  useLockBodyScroll(popopen && !cookie.get('popup') && !!datas?.popup()?.ImgPath)

  function closeToday() {
    if (!cookie.get('popup')) {
      cookie.set('popup', 'home', 24 - dayjs(Date.now()).hour())
      setPopOpen(false)
    }
  }
  const handleImgClick = () => {
    if (datas.popup) {
      monitoredOpen(datas.popup()?.LinkPath || '', 'popup', 'main popup')
    }
  }

  return (
    <>
      {popopen && !cookie.get('popup') && datas?.popup()?.ImgPath && (
        <InProgressPopup>
          <InProgressPopupContent $scale={Math.min(1, window.innerHeight / 603)}>
            <img
              src={`${process.env.REACT_APP_SERVER_IMAGE_URL}${datas.popup()?.ImgPath}`}
              alt="팝업 이미지"
              onClick={handleImgClick}
            />
            <div className="bottom">
              <button className="left" onClick={() => closeToday()}>
                오늘 그만 보기
              </button>
              <div className="vertical_line" />
              <button className="right" onClick={() => setPopOpen(false)}>
                닫기
              </button>
            </div>
          </InProgressPopupContent>
        </InProgressPopup>
      )}
    </>
  )
}
export default Popup
